import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subscription } from 'rxjs';
import { BaseFormKitComponent } from '../../base/base-form-kit.component';



@Component({
    template: ``,
    standalone: false
})

export class BaseChipListSelectSearchProperties extends BaseFormKitComponent {

  @Input() maxTotalCount: number;
  @Input() optimalSearch: boolean = false;
  @Input() isDefaultValue: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() initLoading: boolean = false;
  @Input() isFetchData: boolean = false;
  @Input() isShowSelectAll: boolean = false;
  @Input() isShowDeleteBtn: boolean = true;
  @Input() isDeleteAfterEmit: boolean = false;
  @Input() hasInfiniteScroll: boolean = false;
  @Input() isUseApiFilter: boolean = false;
  @Input() updateItems: number;
  @Input() optionTitle: string;
  @Input() optionValue: string | number;
  @Input() fieldNameToSearch: string;

  @Input() items: any;
  @Output() itemsChange = new EventEmitter<any>();
  @Input() values: any;
  @Output() valuesChange = new EventEmitter<any>();
  @Output() onError = new EventEmitter<boolean>();
  @Output() onRefresh = new EventEmitter<any>();
  @Output() filteredItem = new EventEmitter<any>();

  filterControl: FormControl = new FormControl();
  filteredItems: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedItems: any[] = [];
  isAllSelected: boolean = false
  baseItems: any;

  subscription: Subscription;

  //#endregion




}
